<script>
    export let temperature;
    export let thumbURL;
</script>

<style>
    .temperature-container {
        display: grid;
        text-transform: uppercase;
        text-align: center;
        font-size: 0.7rem;
        justify-items: center;
        align-items: center;
        overflow: hidden; /* since the rotated range still takes up horizontal space lol */
    }
    .temperature-container input[type=range] {
        width: 10rem;
        height: 2rem;
        margin: 0;
    }

    /* rotate for wider displays; on narrower displays, this goes on bottom */
    @media screen and (max-width: 39.999em) {
        .temperature-container {
            grid-template-columns: 1fr 4fr 1fr;
        }
        .temp-slider-wrapper {
            width: 10rem;
            height: 2rem;
        }
    }
    @media screen and (min-width: 40em) {
        .temperature-container {
            grid-template-rows: 1fr 5fr 1fr;
        }
        .temp-slider-wrapper {
            width: 2rem;
            height: 10rem;
        }

        .temperature-container input[type=range] {
            transform-origin: 5rem 5rem;
            transform: rotate(-90deg);
        }

    }
    /* slider madness, generated with http://danielstern.ca/range.css/#/ */
    input[type=range] {
        width: 55%;
        margin: 0.75rem 0;
        background-color: transparent;
        -webkit-appearance: none;
        border: none;
    }
    input[type=range]:focus {
        outline: none;
    }
    input[type=range]::-webkit-slider-runnable-track {
        background: #eeeeee;
        border: 0;
        width: 100%;
        height: 0.15rem;
        cursor: pointer;
    }
    input[type=range]::-webkit-slider-thumb {
        margin-top: -0.75rem;
        width: 1.75rem;
        height: 1.75rem;
        background-image: var(--thumb-url);
        background-color: transparent;
        border: none;
        outline: none;
        background-size: contain;
        cursor: pointer;
        -webkit-appearance: none;
    }
    input[type=range]:focus::-webkit-slider-runnable-track {
        background: #eeeeee;
    }
    input[type=range]::-moz-range-track {
        background: #eeeeee;
        border: 0;
        width: 100%;
        height: 0.15rem;
        cursor: pointer;
    }
    input[type=range]::-moz-range-thumb {
        width: 1.75rem;
        height: 1.75rem;
        background-image: var(--thumb-url);
        background-color: transparent;
        border: none;
        outline: none;
        background-size: contain;
        cursor: pointer;
    }
    input[type=range]::-ms-track {
        background: transparent;
        border-color: transparent;
        border-width: 0.75rem 0;
        color: transparent;
        width: 100%;
        height: 0.15rem;
        cursor: pointer;
    }
    input[type=range]::-ms-fill-lower {
        background: #eeeeee;
        border: 0;
    }
    input[type=range]::-ms-fill-upper {
        background: #eeeeee;
        border: 0;
    }
    input[type=range]::-ms-thumb {
        width: 1.75rem;
        height: 1.75rem;
        background-image: var(--thumb-url);
        background-color: transparent;
        border: none;
        outline: none;
        background-size: contain;
        cursor: pointer;
        margin-top: 0px;
    /*Needed to keep the Edge thumb centred*/
    }
    input[type=range]:focus::-ms-fill-lower {
        background: #eeeeee;
    }
    input[type=range]:focus::-ms-fill-upper {
        background: #eeeeee;
    }
</style>

<div class="temperature-container">
    <div>Weird</div>
    <div style="--thumb-url: url({thumbURL})" class="temp-slider-wrapper"><input type="range" min="0" max="2.0" step="0.1" bind:value="{temperature}" /></div>
    <div>Normal</div>
</div>

